import { notification } from "antd";

// export const DOMAIN = 'http://localhost:8000';
export const DOMAIN = window.location.href.includes("localhost")
  ? "http://localhost:8000"
  : window.location.origin;

export enum CreateStepType {
  Form,
  Workflow,
}

export const getAccessToken = () => {
  const userInfo = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo") || "{}")
    : null;
  return userInfo?.access ?? "";
};

// The standalone form-schema designer (frontend-designer/, its own origin —
// pinned to antd 4, which is why it cannot live inside this bundle). Deep links
// hand the current session over in the URL fragment so an admin is not asked to
// log in twice; a fragment never reaches any server, though it does stay in
// that tab's history. Override per environment with REACT_APP_DESIGNER_URL.
export const DESIGNER_URL =
  process.env.REACT_APP_DESIGNER_URL ||
  (window.location.href.includes("localhost")
    ? "http://localhost:3001"
    : `${window.location.protocol}//${window.location.hostname}:3001`);

export const designerFormUrl = (formId: number) =>
  `${DESIGNER_URL}/?form=${formId}#token=${encodeURIComponent(getAccessToken())}`;

export type NotificationType = "success" | "info" | "warning" | "error";

export const openNotificationWithIcon = (
  type: NotificationType,
  // Shown for a failure too, not only a success: the error branch used to print
  // "Something went wrong." over every refusal, throwing away the sentence the
  // server had written explaining exactly what was wrong.
  description?: string
) => {
  if (type === "success") {
    notification[type]({
      message: "Success",
      description,
    });
  } else {
    notification[type]({
      message: "Error",
      description: description || "Something went wrong.",
    });
  }
};
